import axios from 'axios';

export const GET_WIDGETS = '[ANALYTICS DASHBOARD APP] GET WIDGETS';
export const PIN_POINT_POPOVER = '[WIDGETS MAPS PIN POINT] PIN POINT AND POPOVER DATA';
export const GET_CURRENT_LANGUAGE = '[WIDGETS MAPS PIN POINT] GET CURRENT LANGUAGE';
export const GET_SIDE_MENU_ITEMS_HOME = '[HOME APP] GET SIDEMENU ITEMS';


export function getWidgets() {
	const request = axios.get('/api/analytics-dashboard-app/widgets');

	return dispatch =>
		request.then(response =>
			dispatch({
				type: GET_WIDGETS,
				payload: response.data
			})
		);
}


export function setPinPoint(_companyID, _searchText) {
	/*const tableData = [
		{latitude: 140.2, longitude: 35.2, image:"assets/images/20180117_DiawaHouse.jpeg", title:'Skyscrapper', description:'Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur'},
		{latitude: 139, longitude: 36, image:"assets/images/site_construction.jpeg", title:'Construction Site Saitama', description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'},
		{latitude: 140, longitude: 35.4, image:"", title:'Chiba Site', description:'Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur'},
	]*/

	return async(dispatch)=>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		const companyID = _companyID;
		let searchText = _searchText;
		

		if(!searchText){
			searchText = '';
		}
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/project/project-list?companyID=' + companyID +'&search=' + searchText, headersToken);
		
		return request.then(response => {
			console.log('GET PIN POINT PROJECTS Succesfully', response.data);
			//history.push({ pathname: '/members' });
			return dispatch({
				type: PIN_POINT_POPOVER,
				payload: response.data,
			});
		}).catch( error =>{
			console.log('Could not load data from GET PIN POINT PROJECTS', error.response)
		})

	}

	// return {
	// 	type: PIN_POINT_POPOVER,
	// 	payload: tableData,
	// };
}

export function getCurrentLanguage(data){
	return{
		type: GET_CURRENT_LANGUAGE,
		payload: data
	}
}



//::GET Choosen Side Menu Items
export function getSideMenuItems_home() {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const companyID = localStorage.getItem('persistCompanyID');
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/sideMenu/side-menu-handler?companyID=' + companyID, headersToken)
		
		return request.then(response => {
			console.log('GOT Side Menu Items Succesfully!', response.data);
			return dispatch({
				type: GET_SIDE_MENU_ITEMS_HOME,
				payload: response.data,
			});
		}).catch( error =>{
			console.log('Could not get Side Menu Items', error);

		})
	};
}
